import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import LoginTwoStepEmailStepEmail from './email';
import LoginTwoStepEmailStepPassword from './password';

export default function LoginTwoStepEmail() {
  const location = useLocation();

  const { state } = location;

  return (
    <Routes>
      <Route element={<LoginTwoStepEmailStepEmail />} path="email" />
      <Route element={<LoginTwoStepEmailStepPassword />} path="password" />
      <Route element={<Navigate state={state} to="email" />} path="*" />
    </Routes>
  );
}
